import {
  Button,
  Icon,
  InlineMessage,
  InputField,
  Typography,
} from "@saviynt/design-system";
import { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { validateUsername } from "../../validation";

interface UsernameStepProps {
  username: string;
  onUsernameChange: (value: string) => void;
  onSubmit: (username: string) => void;
  isLoading?: boolean;
  error?: string;
}

export default function UsernameStep({
  username,
  onUsernameChange,
  onSubmit,
  isLoading,
  error,
}: UsernameStepProps) {
  const intl = useIntl();
  const [isCritical, setIsCritical] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const validation = validateUsername(username);
    if (!validation.valid) {
      setIsCritical(true);
      return;
    }
    onSubmit(username);
  };

  const handleUsernameChange = (value: string) => {
    setIsCritical(false);
    onUsernameChange(value);
  };

  return (
    <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
      <InputField
        id="username"
        name="username"
        label={
          <Typography kind="label" htmlFor="username">
            <FormattedMessage
              id="GUK5WY"
              defaultMessage="Username"
              description="Username field label"
            />
          </Typography>
        }
        type="text"
        value={username}
        setValue={handleUsernameChange}
        placeholder={intl.formatMessage({
          id: "r3CKXe",
          defaultMessage: "Enter your username",
          description: "Username field placeholder",
        })}
        isCritical={isCritical}
        setIsCritical={setIsCritical}
        CriticalHelperText={
          <InlineMessage
            text={intl.formatMessage({
              id: "L3hsRD",
              defaultMessage: "Username is required",
              description: "Username required error message",
            })}
            colorTheme="critical"
            size="small"
            leftIcon={<Icon kind="AlertCriticalFilled" />}
          />
        }
      />
      {error && (
        <InlineMessage
          text={error}
          colorTheme="critical"
          kind="background"
          size="small"
          leftIcon={<Icon kind="AlertCriticalFilled" />}
        />
      )}
      <Button
        type="submit"
        size="large"
        className="w-full justify-center"
        isDisabled={isLoading}
      >
        <FormattedMessage
          id="3s73DJ"
          defaultMessage="Continue"
          description="Continue button text"
        />
      </Button>
    </form>
  );
}
